<template>
  <div style="text-align: left;">
    <v-layout row wrap>
      <v-flex xs12 >
        <v-card class='extra-mar'>
          <v-card-title><h3>My Custom Locations</h3></v-card-title>
          <v-card-text>
            <v-data-table
              :items="CustomLocations"
              :headers="headers"
            >
              <template slot="items" slot-scope="props">
                <td><v-icon v-if="props.item.IsFavorite">favorite</v-icon><v-icon v-else>favorite_border</v-icon></td>
                <td>{{props.item.Name}}</td>
                <td>{{props.item.Location.Address}}</td>
                <td>{{props.item.Location.Longitude}},{{props.item.Location.Latitude}}</td>
                <td><v-btn icon @click="_edit(props.item)"><v-icon color="teal lighten-3">edit</v-icon></v-btn></td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class='extra-mar'>
          <v-card-title><h3>All Locations</h3></v-card-title>
          <v-card-text>
            <v-data-table
              :items="Locations"
              :headers="headers"
            >
              <template slot="items" slot-scope="props">
                <td><v-icon v-if="props.item.IsFavorite">favorite</v-icon><v-icon v-else>favorite_border</v-icon></td>
                <td>{{props.item.Name}}</td>
                <td>{{props.item.Location.Address}}</td>
                <td>{{props.item.Location.Longitude}},{{props.item.Location.Latitude}}</td>
                <td><v-btn icon @click="_edit(props.item)"><v-icon color="teal lighten-3">edit</v-icon></v-btn></td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn color="teal lighten-3" @click="_new">add new location</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
    v-model="dialog"
    max-width="850px"
    >
    <v-card>
      <v-card-title>Edit Location {{item.Name}}</v-card-title>
      <v-card-text>
        <v-text-field
          label="Name"
          v-model="item.Name"
        ></v-text-field>
        <v-checkbox
          label="Favorite?"
          v-model="item.IsFavorite"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn color="teal lighten-3" @click="_save">save</v-btn>
        <v-btn color="red lighten-2" @click="_cancel">cancel</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapSetters, mapActions } from 'vuex'
const moduleNamespace = 'locations'
export default {
  page: {
    title: 'Settings'
  },
  data(){
    return {
      headers: [
        {text: '', value: 'IsFavorite', sortable: false},
        {text: 'Name', value: 'Name'},
        {text: 'Address', value: 'Address'},
        {text: 'GeoCode', value: 'geo'},
        {text: '', value: '', sortable: false},
      ],
      dialog: false,
      item: {}
    }
  },
  created(){
    this.getLocations()
  },
  methods: {
    ...mapActions(moduleNamespace, ['getLocations', 'updateLocations', 'createLocations']),
    _edit(val){
      this.item.ID = val.ID
      this.item.Name = val.Name
      this.item.IsFavorite = val.IsFavorite
      this.dialog = !this.dialog
    },
    _save(){
      this.dialog = !this.dialog
      if(this.item.ID > 0){
        this.updateLocations(this.item)
      } else {
        this.createLocations(this.item)
      }
      this.item = {}
    },
    _cancel(){
      this.dialog = !this.dialog
    },
    _new(){
      this.item = { ID: 0 }
      this.dialog = !this.dialog
    },
  },
  computed: {
    ...mapGetters(moduleNamespace, ['Locations', 'CustomLocations'])
  }
}
</script>

<style>
  .extra-mar {
    margin: 10px;
  }
</style>
